export default {
	"contactUs": {
		"title": "開設 FCA 帳戶，您將獲得最權威的監管保護和最安全的資金保障，即刻開設",
		"title1": "每一個認真交易的人，都值得被認真對待。",
		"code": "驗證碼",
	},
	"dividend": {
		"title": "CFD互換率/股息",
		"title1": "每日CFD互換率和股息參攷:",
		"desc": "*請注意：CFD股息收取會在您的MT4帳戶上的餘額裏以存款或者取款形式反映出來，注釋為“Dividend”",
		"btn": "開始投資"
	},
	"notice": "近期我們發現EBC Group與一家提供線上加密貨幣產品名為“EBankc”的公司關聯起來了。<br/><br/>在此我們明確聲明，EBC Group的官方網站為 www.ebc.com  和 www.ebcfin. com ，頁面詳細介紹了我們所提供的產品資訊，並不包含加密貨幣。<br/><br/>同時，EBC Financial Group (UK) Ltd有且僅有一個官方網址 www.ebcfin.co.uk，並對所提供的產品進行了全面的介紹。 加密貨幣不是其中之一。<br/><br/>所有EBC集團公司均根據其經營所在司法管轄區的規則和法規運營，並將採取一切必要措施封锁任何協力廠商在未經授權的項目中使用其品牌。",
	"contact": {
		"title": "您的投資,就此啟程",
		"pageTitle": "開戶諮詢",
		"pageEnTitle": "Inquiry",
		"name": "貴姓 | 稱謂",
		"sexList": [{
			"label": "先生",
			"value": "sir"
		}, {
			"label": "女士",
			"value": "lady"
		}],
		"email": "聯繫電話或郵箱",
		"btn": "發送聯系意願",
		"tips1": "請輸入您的稱呼!",
		"tips2": "請輸入您的聯繫方式!",
		"tips3": "留言成功!",
		"tips4": "請輸入正確的驗證碼!"
	},
	"column1": {
		"placeholder": "全站搜索",
		"login": "客戶登入",
		"langText": "EBC網站地區/語言",
		"langList": [{
			"text": "简中",
			"value": "zh_CN"
		}, {
			"text": "English",
			"value": "en_US"
		}, {
			"text": "한국어",
			"value": "ko_KR"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}, {
			"text": "ئۇيغۇر تىلى",
			"value": "weiwuer"
		}]
	},
	"linkList": [{
		"title": "帳戶及條件",
		"list": [{
				"label": "交易賬戶",
				"link": "/TradingAccount"
			},{
				"label": "交易產品",
				"link": "/tradingproduct"
			},{
				"label": "槓桿保證金",
				"link": "/leverage-margin"
			},
			{
				"label": "出入金",
				"link": "/funding"
			},
			{
				"label": "股息",
				"link": "/dividend"
			}
		]
	},{
		"title": "交易工具",
		"list": [{
				"label": "MT4下載",
				"link": "/MT4"
			},{
				"label": "MT5下載",
				"link": "/MT5"
			},{
				"label": "MT4交易工具",
				"link": "/tools"
			}, {
				"label": "PAMM",
				"link": "/PAMM"
			}, {
				"label": "市場分析",
				"link": "/market-analysis"
			}
		]
	},{
		"title": "EBC研究院",
		"list": [{
				"label": "學習中心",
				"link": "/LearningCenter"
			}, {
				"label": "資料中心",
				"link": "/lab"
			}
		]
	}, {
		"title": "最新活動",
		"list": [{
			"label": "积分商城",
			"link": "PointsMall"
		},{
			"label": "百萬美金交易大賽",
			"link": "/win"
		},
		// {
		// 	"label": "挑戰最强交易環境",
		// 	"link": "/no1"
		// }
		]
	}, {
		"title": "合作夥伴",
		"list": [{
			"label": "影響力聯盟",
			"link": "/affiliate-programmes"
		},{
			"label": "機構服務",
			"link": "/service"
		},{
			"label": "底層科技",
			"link": "/technology"
		}]
	}, {
		"title": "關於EBC",
		"list": [{
			"label": "EBC介紹",
			"link": "/about-us"
		},  {
			"label": "法律文件",
			"link": "/LegalDocumen"
		}, {
			"label": "社會責任",
			"link": "/ESG"
		}, {
			"label": "幫助中心",
			"link": "https://support.ebchelp.com/hc/zh-tw"
		},{
			"label": "官方驗證",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "首頁",
		"url": "/"
	}, {
		"text": "交易",
		"menu": [{
			"text": "交易產品",
			"url": "/tradingproduct"
		}, {
			"text": "交易帳戶",
			"url": "/TradingAccount"
		}, {
			"text": "交易條件",
			"menu": [{
				"text": "出入金",
				"url": "/funding"
			}, {
				"text": "杠杆與保證金",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "交易平臺",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}]
		}, {
			"text": "股息",
			"url": "/dividend"
		}]
	}, {
		"text": "LAB與工具",
		"menu": [{
			"text": "學習中心",
			"url": "/LearningCenter"
		}, {
			"text": "資料中心",
			"url": "/lab"
		}]
	}, {
		"text": "機构合作",
		"menu": [{
			"text": "底層科技",
			"url": "/technology"
		}, {
			"text": "機构服務",
			"url": "/service"
		}, {
			"text": "合作夥伴",
			"url": "/partner"
		}]
	}, {
		"text": "關於EBC",
		"menu": [{
			"text": "Why EBC",
			"url": "/about-us"
		}, {
			"text": "FAQ",
			"url": "/FAQ"
		}]
	}, {
		"text": "交易大賽",
		"url": "/win"
	}, {
		"text": "跟單社區",
		"url": "/from0tohero"
	}, {
		"text": "免費開戶",
		"url": "https://client.ebccrm.com/signup/index"
	}],
	"login": "登入",
	"zhuce": "免費開戶",
	"gendan": "跟單社區",
	"language": "繁體中文",
	"pdfLang": "cn",
	"bannerLang":"tw",
	"className": "ct-box",
	"text": "EBC金融集團是由以下公司集團共享的聯合品牌：<br>EBC Financial Group（SVG）LLC獲批於聖文森特與格林納丁斯金融服務管理局授權和監管，註冊號為353 LLC 2020。<br>其他相關實體<br>EBC Financial Group（UK）Limited 獲批英國金融行為監管局授權和監管，監管號為927552。網址：<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd（公司編號：619 073 237）由澳洲證券和投資委員會授權並監管（監理編號：500991）。 EBC Financial Group (Australia) Pty Ltd 為 EBC Financial Group (SVG) LLC 的關聯實體，兩個實體獨立營運管理。本網站提供的金融產品和服務並非由澳洲公司實體提供，且不涉及澳洲實體的責任。 <br>EBC Financial Group (Cayman) Limited 獲得開曼群島金融管理局許可並受其監管，監管號為2038223。 網址：<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>公司地址：The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB. 郵寄地址： cs@ebc.com 電話：+44 20 3376 9662<br>免責聲明：EBC金融集團明確不參與任何虛擬貨幣業務或者提供虛擬貨幣CFD服務。我們的金融服務只針對傳統金融產品。客戶須知，如有用EBC名義推薦虛擬貨幣有關服務，一律視為誤導，且未經授權。 任何過去的表現都不代表未來表現，網站所含內容只供參考，不構成任何投資建議。<br>地區限制：EBC不向以下地區的居民提供服務，阿富汗、白俄羅斯、緬甸、加拿大、中非共和國、剛果、古巴、剛果民主共和國、厄利垂亞、海地、伊朗、伊拉克、黎巴嫩、利比亞、馬來西亞、馬利、朝鮮（北韓）、俄羅斯、索馬利亞、蘇丹、南蘇丹、敘利亞、 烏克蘭（包括克裡米亞、頓涅茨克和盧甘斯克地區）、美國、委內瑞拉和葉門。 瞭解更多資訊，請查閱我們的常見問題解答。<br>合規披露：公司網站在全球範圍內可見，不針對任何實體。您的權力和義務由您選擇地區的監管以及實體决定。當地法律和監管可能禁止或者限制你進入、下載、傳播、分享或者使用網站上發布的任何檔案和資訊。<br>高風險交易產品披露：CFD是複雜的金融產品，使用杠杆代表著迅速虧損的高風險。 保證金交易蘊含高風險，可能不適用於所有投資者。 您應該結合自身目標、財務情况和風險偏好來衡量上述資訊。 您可能損失一部分或者所有本金。 我們建議您尋求獨立意見，確保您在進行投資決策前充分理解其中風險。 在交易前，請仔細閱讀相關風險披露聲明。",
	"waptext": "EBC金融集團是由以下公司集團共享的聯合品牌：<br>EBC Financial Group（SVG）LLC獲批於聖文森特與格林納丁斯金融服務管理局授權和監管，註冊號為353 LLC 2020。<br>其他相關實體<br>EBC Financial Group（UK）Limited 獲批英國金融行為監管局授權和監管，監管號為927552。網址：<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd（公司編號：619 073 237）由澳洲證券和投資委員會授權並監管（監理編號：500991）。 EBC Financial Group (Australia) Pty Ltd 為 EBC Financial Group (SVG) LLC 的關聯實體，兩個實體獨立營運管理。本網站提供的金融產品和服務並非由澳洲公司實體提供，且不涉及澳洲實體的責任。 <br>EBC Financial Group (Cayman) Limited 獲得開曼群島金融管理局許可並受其監管，監管號為2038223。 網址：<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>公司地址：The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB. 郵寄地址： cs@ebc.com 電話：+44 20 3376 9662<br>免責聲明：EBC金融集團明確不參與任何虛擬貨幣業務或者提供虛擬貨幣CFD服務。我們的金融服務只針對傳統金融產品。客戶須知，如有用EBC名義推薦虛擬貨幣有關服務，一律視為誤導，且未經授權。 任何過去的表現都不代表未來表現，網站所含內容只供參考，不構成任何投資建議。<br>地區限制：EBC不向以下地區的居民提供服務，阿富汗、白俄羅斯、緬甸、加拿大、中非共和國、剛果、古巴、剛果民主共和國、厄利垂亞、海地、伊朗、伊拉克、黎巴嫩、利比亞、馬來西亞、馬利、朝鮮（北韓）、俄羅斯、索馬利亞、蘇丹、南蘇丹、敘利亞、 烏克蘭（包括克裡米亞、頓涅茨克和盧甘斯克地區）、美國、委內瑞拉和葉門。 瞭解更多資訊，請查閱我們的常見問題解答。<br>合規披露：公司網站在全球範圍內可見，不針對任何實體。您的權力和義務由您選擇地區的監管以及實體决定。當地法律和監管可能禁止或者限制你進入、下載、傳播、分享或者使用網站上發布的任何檔案和資訊。<br>高風險交易產品披露：CFD是複雜的金融產品，使用杠杆代表著迅速虧損的高風險。 保證金交易蘊含高風險，可能不適用於所有投資者。 您應該結合自身目標、財務情况和風險偏好來衡量上述資訊。 您可能損失一部分或者所有本金。 我們建議您尋求獨立意見，確保您在進行投資決策前充分理解其中風險。 在交易前，請仔細閱讀相關風險披露聲明。",
}

